import script from "./FAQ.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQ.vue?vue&type=script&setup=true&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=2f05c7f4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3222274153/src/thebrickyardtownhomes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f05c7f4"]])

export default __exports__